export default {
    jqueryHelpers(vue_ref){
        $(".tooltipped").tooltip();

        function charactersRemaining(el){
            var parent = el.parents(".character-count");
            var count = el.val().length;
            var max = parent.attr("data-max");
            var remaining = max - count;
            parent.find(".count").text(remaining);
        }
    
        $(".character-count textarea, .character-count input").on("input", function() {
            charactersRemaining($(this));
        });
    
        $(".character-count").each(function(){
            if ($(this).find("textarea").length){
                charactersRemaining($(this).find("textarea"));
            } 
            if ($(this).find("input").length) {
                charactersRemaining($(this).find("input"));
            } 
        });

        $('.tabs').tabs();

        // There is a set delay for when this is used as a popup for "my libraries", so the popup renders 
        // and the JS then initialises, when used on "my innovations" there is no need...
        //
        setTimeout(function(){
            if ($('.innovation-tags').length) {
                let tags = [];
                let s_tags = [];

                if ($('#dashboard--innovation-library').length || $('#dashboard--innovation-library-single').length) {
                    if ($('.chips-initial').attr('data-existing-tags')) {
                        let existingTags = $('.chips-initial').attr('data-existing-tags');
                        $.each(JSON.parse(existingTags), function (key, tag) {
                            tags.push({"tag": tag.word});
                        });
                    }

                    $(".chips-initial").chips({
                        placeholder: 'Enter a keyword',
                        data: tags
                    });

                    if ($('.s-chips-initial').attr('data-existing-tags')) {
                        let s_existingTags = $('.s-chips-initial').attr('data-existing-tags');
                        $.each(JSON.parse(s_existingTags), function (key, tag) {
                            // Dont push a tag that already exists
                            if(s_tags.includes(tag.word) == false){
                                s_tags.push({"tag": tag.word});
                            }
                        });
                    }

                    $(".s-chips-initial").chips({
                        placeholder: 'Enter a keyword',
                        data: s_tags
                    });
                } else {
                    if ($('.chips-initial').attr('data-existing-tags')) {
                        let existingTags = $('.chips-initial').attr('data-existing-tags');
                        $.each(JSON.parse(existingTags), function (key, tag) {
                            // Dont push a tag that already exists
                            if(tags.includes(tag.name) == false){
                                tags.push({"tag": tag.name});
                            }
                        });
                    }

                    $(".chips-initial").chips({
                        placeholder: 'Enter a tag',
                        data: tags
                    });
                }
            }


            // Trigger save on delete click handler for tags we remove - target from document to include dynamic elements
            $(document).on('click', '.chip .close', function(){

                // 100ms delay so the tag is actually gone, doing it quicker fails
                // Querying .innovation-tags with no delay, included the tag that was just removed 
                //
                setTimeout(function(){
                    // Grab what whats left after we deleted a tag
                    var _tags = [];
                    $('.innovation-tags').children('.chip').each(function(i) { 
                        var text = $(this).clone().children().remove().end().text(); // because theres a child element beside the text we want
                        _tags.push(text); 
                    });

                    // Store revised tag list
                    vue_ref.tags = _tags;
                    vue_ref.saveInnovation(vue_ref.innovation.innovation_status_slug, false, true);
                }, 100);
                
            });

            // Note for later: vue_ref is passed to this function so the jquery based functionality 
            // can talk to the save functionality that eixsts in the vue scope...
            //
            // Still disgustin >:D
            $('.innovation-tags').find("input").on('keyup', function(e){
                if(e.key === 'Enter' || e.keyCode === 13){

                    // Do this check on the innovation page not the innovation-library page
                    // The form is used in multiple places...
                    //
                    if(window.location.href.indexOf("/innovation/") > -1){
                        // Add validation here because if the required fields dont exist SQL constraints
                        // for adding tags to an innovation will fail
                        if(vue_ref.requiredFields() != true){
                            vue_ref.$toasted.error('Complete step 1 before adding tags');
                            $(this).prev().remove(); // Remove the tag the user tried to add as validation failed.
                            return; 
                        }
                    }

                    // Grab what we just added so it can be saved
                    var _tags = [];
                    $('.innovation-tags').children('.chip').each(function(i) { 
                        var text = $(this).clone().children().remove().end().text(); // because theres a child element beside the text we want
                        // Dont push a tag that already exists
                        if(_tags.includes(text) == false){
                            _tags.push(text); 
                        }else{
                            vue_ref.$toasted.error('Tag already exists');
                        }
                    });

                    // Note: assign to .tags instead of innovation.tags otherwise saves start duplicating
                    vue_ref.tags = _tags;
                    vue_ref.saveInnovation(vue_ref.innovation.innovation_status_slug, false, true);                      
                }
            });

        }, 1000);
    }
}